import { useState } from "react";

export default function CTABand() {
  const [done, setDone] = useState(false);

  return (
    <section id="subscribe" className="w-full border-b border-line">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-xl border border-line bg-ink px-6 py-10 md:px-10 md:py-14">
          {/* 装饰 */}
          <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
            <i className="ri-radar-line absolute -right-10 -top-14 text-[240px] text-cream"></i>
          </div>

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <span className="text-xs font-medium uppercase tracking-widest text-gold-soft">
                Stay Ahead
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-cream md:text-3xl">
                别等热度过去，<br />
                第一手流出先到你手上
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-cream/70">
                留下方式，新近曝光、新瓜与求证结论更新时第一时间提醒你——不留，也不打扰。
              </p>

              <div className="mt-6 flex max-w-md items-center gap-2 rounded-md border border-cream/20 bg-cream/5 p-1">
                <i className="ri-mail-line pl-3 text-lg text-cream/60"></i>
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱，订阅一手流出"
                  autoComplete="off"
                  className="min-w-0 flex-1 bg-transparent px-2 py-2 text-sm text-cream placeholder:text-cream/40 focus:outline-none"
                />
                <button
                  type="button"
                  onClick={() => setDone(true)}
                  className={`shrink-0 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    done
                      ? "bg-gold text-ink"
                      : "bg-cream text-ink hover:bg-gold"
                  }`}
                >
                  {done ? "已加入队列 ✓" : "订阅追踪"}
                </button>
              </div>
              <p className="mt-3 text-xs text-cream/40">
                演示按钮，不真实提交 · 每周精选 1–2 封
              </p>
            </div>

            {/* 入口 / 下载更醒目 */}
            <div className="flex flex-col gap-3">
              {[
                { icon: "ri-download-2-line", title: "线下存档包", desc: "已整理专题 PDF 合集，一次性下载带走" },
                { icon: "ri-apps-2-line", title: "移动端轻应用", desc: "碎片时间刷追踪，扫码即用、无需安装" },
                { icon: "ri-chat-3-line", title: "求证社群入口", desc: "与同好一起交叉核验，少走冤枉路" },
              ].map((item) => (
                <a
                  key={item.title}
                  href="#top"
                  className="group flex items-center gap-4 rounded-lg border border-cream/15 bg-cream/5 px-4 py-3 transition-colors hover:bg-cream/10"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-gold text-ink">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-semibold text-cream">{item.title}</span>
                    <span className="block truncate text-xs text-cream/60">{item.desc}</span>
                  </span>
                  <i className="ri-arrow-right-up-line ml-auto text-lg text-cream/40 transition-colors group-hover:text-gold"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}